import React from "react";
import { FaArrowUpRightFromSquare, FaTriangleExclamation } from "react-icons/fa6";

interface CustomerAccessBannerProps {
    supportEmail?: string | null;
}

const CustomerAccessBanner = ({ supportEmail }: CustomerAccessBannerProps) => {
    const email = supportEmail?.trim();
    // Replace when National Tax Data supplies its sign-in URL.
    const ntdSignInUrl = "https://ntd.example.invalid";

    return (
        <section role="status" aria-live="polite" aria-label="Account migration notice"
                 className="flex items-start gap-3 rounded border border-l-4 border-warn-0 bg-warn-2 p-4 text-surface-0">
            <FaTriangleExclamation className="mt-1 shrink-0" aria-hidden="true" />
            <div className="min-w-0">
                <p className="font-semibold">Your account has been migrated</p>
                <p className="mt-1 text-sm">
                    Continue in National Tax Data (NTD).{" "}
                    {email ? <>For assistance, email{" "}
                        <a href={`mailto:${email}`} className="break-all underline underline-offset-2">{email}</a>.
                    </> : "For assistance, contact support."}
                </p>
                <a href={ntdSignInUrl} target="_blank" rel="noopener noreferrer"
                   className="mt-3 inline-flex items-center gap-2 rounded bg-highlight-0 px-3 py-2 text-sm text-text-0 hover:bg-highlight-6">
                    Go to NTD <FaArrowUpRightFromSquare aria-hidden="true" />
                </a>
            </div>
        </section>
    );
};

export default CustomerAccessBanner;
